module.exports = __webpack_public_path__ + "img/music_005.25e4b969.png";